<template>
    <div>
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Live Class Teacher',
                    to: { path: '/live-class-teacher' },
                },
                { text: 'Live Class Detail' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Live Class Detail</h3>

        <v-layout class="pt-0 px-0 pb-3 mb">
            <v-btn
                id="set-class"
                class="mr-2"
                :class="tab == 3 ? 'darkFade--text' : 'white--text'"
                :color="tab == 3 ? 'white' : 'blew'"
                elevation="0"
                @click="tab = 1"
                >Set Kelas</v-btn
            >

            <v-btn
                id="on-live-class"
                :class="tab == 3 ? 'white--text' : 'darkFade--text'"
                :color="tab == 3 ? 'blew' : 'white'"
                class="mr-2"
                elevation="0"
                @click="tab = 3"
                >On Live Class</v-btn
            >
        </v-layout>

        <!-- <div class="d-flex flex-column justify-space-between align-center mb-5">
      <v-img :src="$store.state.liveclassteacher.thumbnail" width="50%"></v-img>
    </div> -->
        <v-card v-show="tab == 1">
            <v-card-title>
                Quiz
                <v-spacer></v-spacer>
                <v-btn
                    class="align-center text-body-2 blew white--text"
                    text
                    color="#e8f5fa"
                    @click="addQuiz"
                    ><v-icon left class="pr-2"> mdi-plus-circle </v-icon> Tambah
                    Quiz
                </v-btn>
            </v-card-title>
            <v-card-text class="px-5">
                <div class="mt-5 blue--text">
                    <v-select
                        id="select_quiz"
                        v-model="quizSelected"
                        v-on:change="getQuizId(quizSelected)"
                        :items="quiz"
                        item-text="name"
                        item-value="id"
                        height="36px"
                        placeholder="Pilih Quiz"
                        class="select_box my-2"
                        style="background-color: #e8f5fa"
                        outlined
                        hide-details
                    ></v-select>
                </div>

                <div>
                    <v-select
                        id="select_duration"
                        v-model="timer"
                        :items="duration"
                        item-text="name"
                        item-value="id"
                        height="36px"
                        placeholder="Pilih Durasi"
                        class="select_box my-5"
                        outlined
                        hide-details
                    ></v-select>
                    <v-container class="grey lighten-5 text-center">
                        <v-row no-gutters class="blue--text mb-2">
                            <v-col cols="3">
                                <span class="pa-2 pr-5"> Opsi</span>
                            </v-col>
                            <v-col cols="8">
                                <span class="pa-2"> Kunci</span>
                            </v-col>
                        </v-row>
                        <v-divider />
                        <div
                            v-for="(option, index) in options"
                            v-bind:key="index"
                        >
                            <v-row class="blue--text my-5">
                                <v-col cols="3">
                                    <!-- <span
                    class="flex px-5 py-5 rounded-circle justify-center align-center"
                    style="background-color: #e8f5fa"
                  >
                    {{ option.choice }}</span
                  > -->
                                    <v-btn fab depressed class="blue--text">
                                        {{ option.choice }}
                                    </v-btn>
                                </v-col>
                                <v-col cols="8">
                                    <v-select
                                        v-model="option.answer"
                                        :items="keyOptions"
                                        item-text="name"
                                        item-value="name"
                                        max-width="10px"
                                        class="select_key mt-1"
                                        style="background-color: #e8f5fa"
                                        outlined
                                        rounded
                                        hide-details
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </div>

                        <div
                            class="d-flex py-3 px-3 justify-center align-center"
                        >
                            <v-btn
                                class="white--text"
                                width="100%"
                                depressed
                                color="#2690cb"
                                @click="setQuiz"
                                >Save</v-btn
                            >
                        </div>
                    </v-container>
                </div>
            </v-card-text>
        </v-card>

        <div v-show="tab == 3">
            <v-card
                v-if="
                    statusLive != 'STARTED' &&
                    statusLive != 'DISABLED_CHAT' &&
                    statusLive != 'DIVERTED'
                "
                class="mb-5 pb-3"
            >
                <div
                    class="d-flex py-3 px-3 rounded-tl justify-center align-center"
                >
                    <h4>Tidak Sedang Live</h4>
                </div>
                <div
                    class="d-flex py-2 px-3 rounded-tl justify-center align-center"
                >
                    <v-btn
                        class="white--text"
                        width="100%"
                        depressed
                        color="#6FCF97"
                        @click="startLiveClass"
                        >Mulai Live</v-btn
                    >
                </div>
                <!-- <div class="d-flex py-2 px-3 rounded-tl justify-center align-center">
          <v-btn
            class="white--text mb-4"
            width="100%"
            depressed
            color="#2690cb"
            @click="onDivert = true"
            >Alihkan ke Live Zoom</v-btn
          >
        </div> -->
            </v-card>
            <v-card
                v-if="statusLive == 'STARTED' || statusLive == 'DISABLED_CHAT'"
                class="mb-5 pb-3"
            >
                <div
                    class="d-flex py-2 px-3 rounded-tl justify-center align-center"
                >
                    <h4>
                        <v-icon small color="#FF647C">mdi-circle</v-icon> Sedang
                        Live
                    </h4>
                </div>
                <div
                    class="d-flex py-2 px-3 rounded-tl justify-center align-center"
                >
                    <v-btn
                        class="white--text"
                        width="100%"
                        depressed
                        color="#FF647C"
                        @click="isEndLive = true"
                        >Hentikan Live</v-btn
                    >
                </div>
                <!-- <div class="d-flex py-3 px-3 rounded-tl justify-center align-center">
          <v-btn
            class="white--text mb-4"
            width="100%"
            depressed
            color="#2690cb"
            @click="onDivert = true"
            >Alihkan ke Live Zoom</v-btn
          >
        </div> -->
            </v-card>
            <v-card v-if="statusLive == 'DIVERTED'" class="mb-5">
                <div
                    class="d-flex py-3 px-3 rounded-tl justify-center align-center"
                >
                    <h4>Live Class Dialihkan</h4>
                </div>
                <div
                    class="d-flex py-3 px-3 rounded-tl justify-center align-center"
                >
                    <v-btn
                        class="white--text"
                        width="100%"
                        depressed
                        disabled
                        color="#FF647C"
                        >Mulai Live Class</v-btn
                    >
                </div>
                <div
                    class="d-flex py-3 px-3 rounded-tl justify-center align-center"
                >
                    <v-btn
                        class="white--text"
                        width="100%"
                        depressed
                        color="#2690cb"
                        @click="onWaitingClass"
                        >Kembali ke Live Stream</v-btn
                    >
                </div>
            </v-card>

            <div class="mb-5">
                <v-card>
                    <v-card-title>
                        Live Chat
                        <v-spacer></v-spacer>
                        <v-btn
                            v-if="!isDisabled"
                            class="white--text"
                            depressed
                            color="#FF647C"
                            @click="disabledChat"
                            >Disable Chat</v-btn
                        >
                        <v-btn
                            v-if="isDisabled"
                            class="white--text"
                            depressed
                            color="#6FCF97"
                            @click="enabledChat"
                            >Enable Chat</v-btn
                        >
                    </v-card-title>
                    <v-card-text class="px-0 pt-0">
                        <template>
                            <template
                                style="width: 100%; background-color: #f5f8ff"
                            >
                                <v-sheet
                                    id="scroll-target"
                                    class="overflow-y-auto pt-2"
                                    style="max-height: 300px"
                                    :style="
                                        $vuetify.breakpoint.lgAndUp
                                            ? 'height: 79%'
                                            : 'height: 79%'
                                    "
                                >
                                    <!-- chat history -->
                                    <div
                                        v-for="(message, index) in messages"
                                        :key="index"
                                    >
                                        <!-- pesan Text -->
                                        <v-row
                                            v-if="message.type === 1"
                                            class="text-right py-2"
                                            :class="
                                                $vuetify.breakpoint.smAndDown
                                                    ? 'mx-2'
                                                    : 'mx-3'
                                            "
                                            :justify="
                                                message.user_id ===
                                                $store.state.usman.user_id
                                                    ? 'end'
                                                    : 'start'
                                            "
                                            align="end"
                                        >
                                            <v-col
                                                class="pa-1 text-left"
                                                cols="1"
                                                align-self="center"
                                            >
                                                <v-avatar left size="30">
                                                    <v-img
                                                        :src="message.url_img"
                                                    ></v-img>
                                                </v-avatar>
                                            </v-col>
                                            <v-col
                                                class="text-left"
                                                cols="11"
                                                align-self="center"
                                            >
                                                <div
                                                    class="roboto-text text-left font-weight-200 putih--text"
                                                    style="
                                                        font-size: 14px;
                                                        padding-left: 10px;
                                                    "
                                                    :class="
                                                        message.user_id ===
                                                        $store.state.usman
                                                            .user_id
                                                            ? ''
                                                            : ''
                                                    "
                                                    elevation="2"
                                                    :max-width="
                                                        $vuetify.breakpoint
                                                            .smAndDown
                                                            ? 172
                                                            : 443
                                                    "
                                                    :style="
                                                        message.user_id ===
                                                        $store.state.usman
                                                            .user_id
                                                            ? 'color: #464958'
                                                            : 'color: #181818'
                                                    "
                                                >
                                                    <span
                                                        v-if="
                                                            message.user_name &&
                                                            message.user_id !==
                                                                $store.state
                                                                    .usman
                                                                    .user_id
                                                        "
                                                        class="grey--text mr-1"
                                                    >
                                                        {{ message.user_name }}
                                                    </span>
                                                    <span
                                                        v-if="
                                                            message.user_name &&
                                                            message.user_id ===
                                                                $store.state
                                                                    .usman
                                                                    .user_id
                                                        "
                                                        class="grey--text mr-1"
                                                    >
                                                        Anda
                                                    </span>
                                                    <span>{{
                                                        message.message
                                                    }}</span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-sheet>
                            </template>
                        </template>
                    </v-card-text>
                    <v-card-actions
                        v-if="!isDisabled"
                        class="d-flex pa-2 py-3 border-top-1 card-actions"
                    >
                        <template>
                            <v-text-field
                                v-model="message"
                                class="searchbar rounded-pill ma-1"
                                rounded
                                height="37px"
                                hide-details=""
                                style="padding-right: 30px"
                                placeholder="Ketik pesanmu"
                                @keyup.enter="
                                    message && !chatLoading
                                        ? saveMessage(1)
                                        : null
                                "
                            >
                            </v-text-field>
                            <v-btn
                                depressed
                                color="#67bbdf"
                                rounded
                                min-width="36px"
                                min-height="36px"
                                class="chat-btn mr-5"
                                dark
                                :loading="chatLoading"
                                @click="
                                    message && !chatLoading
                                        ? saveMessage(1)
                                        : null
                                "
                            >
                                <svg
                                    v-if="!chatLoading"
                                    width="13"
                                    height="13"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M10.8151 10.1968L3.28308 11.4528C3.19649 11.4673 3.11522 11.5043 3.04746 11.5601C2.97971 11.6159 2.92784 11.6886 2.89708 11.7708L0.30008 18.7278C0.0520799 19.3678 0.72108 19.9778 1.33508 19.6708L19.3351 10.6708C19.4598 10.6086 19.5646 10.5128 19.6379 10.3943C19.7112 10.2758 19.75 10.1392 19.75 9.99984C19.75 9.86049 19.7112 9.72389 19.6379 9.60537C19.5646 9.48685 19.4598 9.39109 19.3351 9.32884L1.33508 0.32884C0.72108 0.0218396 0.0520799 0.63284 0.30008 1.27184L2.89808 8.22884C2.92869 8.31125 2.9805 8.38414 3.04827 8.44014C3.11604 8.49615 3.19737 8.5333 3.28408 8.54784L10.8161 9.80284C10.8624 9.81096 10.9044 9.83516 10.9347 9.8712C10.965 9.90723 10.9816 9.95278 10.9816 9.99984C10.9816 10.0469 10.965 10.0925 10.9347 10.1285C10.9044 10.1645 10.8624 10.1887 10.8161 10.1968H10.8151Z"
                                        :fill="'white'"
                                    />
                                </svg>

                                <!-- <v-progress-circular
                      v-if="chatLoading"
                      :width="2"
                      :size="18"
                      color="white"
                      indeterminate
                    ></v-progress-circular> -->
                            </v-btn>
                        </template>
                    </v-card-actions>
                </v-card>
            </div>

            <v-card>
                <v-tabs>
                    <v-tab> Quiz </v-tab>
                    <v-tab>
                        Participant
                        <v-btn
                            depressed
                            rounded
                            small
                            dark
                            color="primary"
                            class="ml-2 white--text"
                        >
                            <v-icon left> mdi-account-multiple </v-icon>
                            {{ studentCount }}
                        </v-btn>
                    </v-tab>
                    <!-- <v-tab> Live Chat </v-tab> -->

                    <v-tab-item class="pa-3 pt-3">
                        <v-card
                            flat
                            tile
                            color="rgba(230, 230, 230, 0.08)"
                            class="d-flex justify-space-around border-top-divider"
                            v-for="(quiz, index) in arrayQuiz"
                            v-bind:key="index"
                        >
                            <v-card-text>
                                <v-layout>
                                    <span class="py-2 px-2 blue--text">
                                        Quiz {{ index + 1 }}
                                    </span>
                                    <v-btn
                                        depressed
                                        :color="
                                            quiz_active === index + 1
                                                ? 'success'
                                                : 'primary'
                                        "
                                        class="px-5 ml-3 white--text"
                                        @click="getDetailQuiz(index + 1)"
                                    >
                                        <!-- <span v-if="quiz_active === index + 1">Published</span>
                    <span v-if="quiz_active !== index + 1">Publish</span> -->
                                        Publish
                                    </v-btn>
                                    <v-btn
                                        depressed
                                        color="success"
                                        class="px-5 ml-3 white--text"
                                        :disabled="quiz_active !== index + 1"
                                        @click="getResultQuiz(index + 1)"
                                    >
                                        Live Quiz
                                    </v-btn>
                                    <v-btn
                                        v-if="show_result === ''"
                                        depressed
                                        color="primary"
                                        class="px-5 ml-3 white--text"
                                        @click="getResult(index + 1)"
                                    >
                                        Result
                                    </v-btn>
                                    <v-btn
                                        v-if="show_result !== ''"
                                        depressed
                                        color="#FF647C"
                                        class="px-5 ml-3 white--text"
                                        @click="removeStatus()"
                                    >
                                        End Result
                                    </v-btn>
                                </v-layout>

                                <div
                                    v-if="
                                        showResultDialog &&
                                        quiz_active === index + 1
                                    "
                                    class="mt-5"
                                    style="margin-left: 60px"
                                >
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-card flat>
                                                <v-card-text class="pt-3">
                                                    <div
                                                        class="roboto-text darkblue--text font-weight-700 mb-3"
                                                        style="font-size: 18px"
                                                    >
                                                        Live Quiz
                                                    </div>
                                                    <div
                                                        class="text-left"
                                                        style="font-size: 16px"
                                                    >
                                                        Submission :
                                                        <b>
                                                            {{
                                                                answer_count
                                                            }}/{{
                                                                studentCount
                                                            }}
                                                            ({{
                                                                quiz_percentation
                                                            }}%) Jawaban</b
                                                        >
                                                    </div>
                                                    <div class="text-left mt-5">
                                                        <v-btn
                                                            color="#E6F8FF"
                                                            depressed
                                                        >
                                                            <span
                                                                class="primary--text"
                                                            >
                                                                {{
                                                                    countdown_quiz
                                                                }}
                                                            </span>
                                                        </v-btn>
                                                    </div>

                                                    <div
                                                        v-if="
                                                            answer_count <= 0 &&
                                                            !loading_answer
                                                        "
                                                        class="text-center mt-5 darkblue--text font-weight-600"
                                                        style="
                                                            font-size: 16px;
                                                            padding: 10px 0px;
                                                            background-color: #f3f5f7;
                                                        "
                                                    >
                                                        Belum ada yang menjawab
                                                        Quiz
                                                    </div>

                                                    <div>
                                                        <BarChart
                                                            v-if="
                                                                showResultDialog
                                                            "
                                                            :data="data_chart"
                                                        />
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card
                            flat
                            tile
                            color="rgba(230, 230, 230, 0.08)"
                            class="border-top-divider mt-2 mb-5"
                        >
                            <v-card-text>
                                <div
                                    class="mt-2"
                                    style="max-height: 400px; overflow: auto"
                                >
                                    <v-card
                                        v-for="(student, index) in studentList"
                                        v-bind:key="index"
                                        class="mb-2 pa-2"
                                        outlined
                                    >
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="8" class="pt-1">
                                                    <span
                                                        style="font-size: 16px"
                                                        block
                                                        class="darkblue--text"
                                                    >
                                                        {{ student.name }}
                                                    </span>
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-btn
                                                        depressed
                                                        color="#FF647C"
                                                        class="px-5 ml-2 white--text"
                                                        v-if="
                                                            student.suspend ==
                                                            false
                                                        "
                                                        @click="
                                                            onConfirmSuspend(
                                                                student.id
                                                            )
                                                        "
                                                    >
                                                        Suspend
                                                    </v-btn>
                                                    <v-btn
                                                        depressed
                                                        color="#67BBDF"
                                                        class="px-5 white--text"
                                                        v-if="
                                                            student.suspend ==
                                                            true
                                                        "
                                                        @click="
                                                            onUnsupendStudent(
                                                                student.id
                                                            )
                                                        "
                                                    >
                                                        Unsuspend
                                                    </v-btn>

                                                    <v-btn
                                                        depressed
                                                        color="#67BBDF"
                                                        class="px-5 ml-2 white--text"
                                                        v-if="
                                                            student.disable_chat ==
                                                            true
                                                        "
                                                        @click="
                                                            onEnabledStudent(
                                                                student.id
                                                            )
                                                        "
                                                    >
                                                        Enable Chat
                                                    </v-btn>

                                                    <v-btn
                                                        depressed
                                                        color="#ff647c"
                                                        class="px-5 ml-2 white--text"
                                                        v-if="
                                                            student.disable_chat ==
                                                            false
                                                        "
                                                        @click="
                                                            onDisabledStudent(
                                                                student.id
                                                            )
                                                        "
                                                    >
                                                        Disable Chat
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
            </v-card>
        </div>

        <v-dialog
            v-if="onDivert"
            v-model="onDivert"
            @click:outside="onDivert = false"
            max-width="290"
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title style="word-break: break-word !important">
                        Apakah Anda yakin ingin mengalihkan live class ini ke
                        Live Class Zoom?
                    </v-card-title>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn color="blew" text @click="onDivertClass()">
                            Ya
                        </v-btn>
                        <v-btn color="darkFade" text @click="onDivert = false">
                            Batal
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <v-dialog
            v-if="isEndLive"
            v-model="isEndLive"
            @click:outside="isEndLive = false"
            max-width="290"
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title style="word-break: break-word !important">
                        Apakah Anda yakin ingin menghentikan live class ini?
                    </v-card-title>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn color="blew" text @click="endLiveClass()">
                            Ya
                        </v-btn>
                        <v-btn color="darkFade" text @click="isEndLive = false">
                            Batal
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <v-dialog
            v-if="showQuiz"
            v-model="showQuiz"
            max-width="360px"
            @click:outside="showQuiz = false"
        >
            <v-card tile class="text-center">
                <v-card-title class="text-h5" style="word-break: break-word">
                    Quiz {{ dataQuiz.id }}
                </v-card-title>
                <!-- <v-card-text> A, B, C, D, E </v-card-text> -->
                <v-card-text> Kunci: {{ dataQuiz.answer }} </v-card-text>
                <v-card-text> Durasi: {{ timer }} Detik </v-card-text>
                <v-card-text class="font-weight-bold"> Publish? </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darkFade" text @click="showQuiz = false">
                        Back
                    </v-btn>
                    <v-btn color="blew" text @click="onShowQuiz(dataQuiz.id)">
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-if="showResult"
            v-model="showResult"
            max-width="360px"
            @click:outside="showResult = false"
        >
            <v-card tile>
                <v-card-title class="text-h5" style="word-break: break-word">
                    Result Quiz {{ result.id }}
                </v-card-title>
                <v-card-text class="text-center"
                    >Submission: {{ result.total }}
                </v-card-text>
                <v-card-text>
                    A. {{ result.sumA }} siswa ({{ result.a }}%)</v-card-text
                >
                <v-card-text>
                    B. {{ result.sumB }} siswa ({{ result.b }}%)</v-card-text
                >
                <v-card-text>
                    C. {{ result.sumC }} siswa ({{ result.c }}%)</v-card-text
                >
                <v-card-text>
                    D. {{ result.sumD }} siswa ({{ result.d }}%)</v-card-text
                >
                <v-card-text>
                    E. {{ result.sumE }} siswa ({{ result.e }}%)</v-card-text
                >
                <v-card-text class="font-weight-bold">
                    Jawaban: {{ result.answer }}
                </v-card-text>
                <v-card-text class="font-weight-bold"> Publish? </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darkFade" text @click="showResult = false">
                        Back
                    </v-btn>
                    <v-btn color="blew" text @click="publishResult(result.id)">
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-if="confirmSuspend.open"
            v-model="confirmSuspend.open"
            max-width="360px"
            @click:outside="confirmSuspend.open = false"
        >
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ confirmSuspend.title }}
                </v-card-title>
                <v-card-text>
                    {{ confirmSuspend.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="
                            confirmSuspend.open = false;
                            confirmSuspend.title = null;
                            confirmSuspend.function = null;
                        "
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        text
                        @click="
                            onSuspendStudent(confirmSuspend.function);
                            confirmSuspend.open = false;
                            confirmSuspend.title = null;
                            confirmSuspend.function = null;
                        "
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import firebase from "firebase";
import moment from "moment";
import LiveClassTeacherService from "@/modules/live_class_teacher/services/liveclassteacher.js";
import BarChart from "./BarChart.vue";
import axios from "axios";

export default {
    name: "live-class-teacher-detail",
    components: {
        BarChart,
    },
    data: function () {
        return {
            tab: 1,
            loading: false,
            showQuiz: false,
            showResult: false,
            isEndLive: false,
            onDivert: false,
            chatLoading: false,
            confirmSuspend: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            studentList: [],
            student_id: [],
            message: null,
            messages: [],
            isLive: false,
            isDisabled: false,
            isResult: false,
            studentCount: 0,
            statusLive: "",
            quiz: [],
            timer: 60,
            dataQuiz: [],
            keyOptions: [
                {
                    id: 1,
                    name: "Benar",
                },
                {
                    id: 2,
                    name: "Salah",
                },
                {
                    id: 3,
                    name: "Kosong",
                },
            ],
            duration: [
                {
                    id: 10,
                    name: "10 detik",
                },
                {
                    id: 30,
                    name: "30 detik",
                },
                {
                    id: 60,
                    name: "60 detik",
                },
                {
                    id: 120,
                    name: "120 detik",
                },
                {
                    id: 180,
                    name: "180 detik",
                },
            ],
            options: [
                {
                    id: 1,
                    choice: "A",
                    answer: "Salah",
                },
                {
                    id: 2,
                    choice: "B",
                    answer: "Salah",
                },
                {
                    id: 3,
                    choice: "C",
                    answer: "Salah",
                },
                {
                    id: 4,
                    choice: "D",
                    answer: "Salah",
                },
                {
                    id: 5,
                    choice: "E",
                    answer: "Salah",
                },
            ],
            isSuspend: false,
            thumbnail: "",
            differenceMin: 0,
            lcrId: "",
            statusLive: false,
            quizSelected: null,
            count: 0,
            arrayQuiz: [],
            quiz_id: null,
            result: null,
            n: 0,
            countdownQuiz: "00:00",
            countdownResult: "00:00",
            quizInterval: 0,
            resultInterval: 0,
            show_quiz: "",
            show_result: "",
            showResultDialog: false,
            data_chart: [],
            result_quiz_data: null,
            data_class: null,
            countdown_quiz: "00:00",
            quizInterval2: 0,
            quiz_percentation: 0,
            answer_count: 0,
            quiz_active: null,
            loading_answer: true,
        };
    },

    created() {
        this.fetchData();
    },

    mounted() {},

    methods: {
        async fetchData() {
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios
                .get(
                    `${process.env.API_BASE_URL}liveclass/admin/detailclass/${this.$route.query.id}`,
                    options
                )
                .then((result) => {
                    this.$emit("selected", result.data);
                    this.$store.commit("live_class_teacher_init", result.data);

                    this.lcrId = result.data.liveclassroomId;
                    this.getAllStatus();
                    this.setDifferenceTime();
                    this.getListStudent();
                    this.getStatusLive();
                    this.thumbnail =
                        this.$store.state.liveclassteacher.thumbnail;
                    this.statusLive =
                        this.$store.state.liveclassteacher.statusLive;
                    this.getQuiz();

                    this.fetchMessages();

                    setTimeout(() => {
                        this.scrollToBottom();
                    }, 1000);
                });
        },

        getAllStatus() {
            var docRef = firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId);
            docRef.onSnapshot((doc) => {
                var data = doc.data();
                this.data_class = data;
                this.show_quiz = data.show_quiz;
                this.show_result = data.show_result;
            });
        },

        removeStatus() {
            this.isResult = false;

            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .update({
                    show_quiz: "",
                    end_time_quiz: 0,
                    show_result: "",
                    end_time_result: 0,
                });

            this.countdownQuiz = "00:00";
            this.countdownResult = "00:00";
        },

        setDifferenceTime() {
            var now = moment(new Date(), "DDMMYYYY HH:mm");
            var startLive = moment(
                this.$store.state.liveclassteacher.startAt,
                "DDMMYYYY HH:mm"
            );
            this.differenceMin = now.diff(startLive, "minutes");
        },

        addQuiz() {
            var row = {
                id: this.quiz.length + 1,
                name: "Quiz " + (this.quiz.length + 1),
            };

            var index = this.quiz.length;

            this.quiz.splice(index, 0, row);
        },

        resetQuiz() {
            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .update({
                    show_quiz: "",
                    end_time_quiz: 0,
                });
        },

        resetResult() {
            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .update({
                    show_result: "",
                    end_time_result: 0,
                });
        },

        setQuizArray(arr) {
            var row = {
                id: arr.length,
                name: "Quiz " + arr.length,
            };
            this.quiz = row;
        },

        getQuiz() {
            this.arrayQuiz = [];
            this.quiz = [];

            var docRef = firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .collection("quiz");
            docRef.onSnapshot((doc) => {
                this.arrayQuiz = [];
                this.quiz = [];

                doc.forEach((doc) => {
                    this.arrayQuiz.push(doc.data());
                    var row = {
                        id: this.arrayQuiz.length,
                        name: "Quiz " + this.arrayQuiz.length,
                    };
                    this.quiz.push(row);

                    // this.setQuizArray(this.arrayQuiz);
                });
            });
        },

        getQuizId(id) {
            var answer = "";
            var total = 0;

            this.keyOptions = [
                {
                    id: 1,
                    name: "Benar",
                },
                {
                    id: 2,
                    name: "Salah",
                },
                {
                    id: 3,
                    name: "Kosong",
                },
            ];

            (this.options = [
                {
                    id: 1,
                    choice: "A",
                    answer: "Salah",
                },
                {
                    id: 2,
                    choice: "B",
                    answer: "Salah",
                },
                {
                    id: 3,
                    choice: "C",
                    answer: "Salah",
                },
                {
                    id: 4,
                    choice: "D",
                    answer: "Salah",
                },
                {
                    id: 5,
                    choice: "E",
                    answer: "Salah",
                },
            ]),
                this.options.forEach(function (item) {
                    item.answer = "Salah";
                });

            var docRef = firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .collection("quiz")
                .doc("quiz_" + id);
            docRef.onSnapshot((doc) => {
                var data = doc.data();
                this.timer = data.timer;
                total = data.total_choice;
                answer = data.quiz_answer;

                this.options.forEach(function (item) {
                    if (item.id <= total) {
                        let i = 0;
                        for (i; i < total; i++) {
                            item.id = item.id + 1;
                            item.answer = "Salah";
                        }
                    } else {
                        item.answer = "Kosong";
                    }

                    if (answer === item.choice) {
                        item.answer = "Benar";
                    }
                });
            });
        },

        setQuiz() {
            var answer = "";
            var seconds = this.timer;
            var total = 5;

            this.options.forEach(function (item) {
                if (item.answer === "Kosong" || item.answer === "") {
                    total = total - 1;
                }

                if (item.answer === "Benar") {
                    answer = item.choice;
                }
            });

            if (this.quizSelected === null) {
                this.$store.commit("showAlert", {
                    message: `Kamu belum tambah/pilih kuis`,
                    type: "error",
                });
            } else {
                firebase
                    .firestore()
                    .collection("live_class_room")
                    .doc(this.lcrId)
                    .collection("quiz")
                    .doc("quiz_" + this.quizSelected)
                    .set({
                        quiz_answer: answer,
                        timer: seconds,
                        total_choice: total,
                    });

                this.$store.commit("showAlert", {
                    message: `Berhasil simpan Quiz ` + this.quizSelected,
                    type: "success",
                });
            }
        },

        onConfirmSuspend(id) {
            this.confirmSuspend.title =
                "Apakah Anda yakin akan menangguhkan siswa ini?";
            this.confirmSuspend.function = id;
            this.confirmSuspend.open = true;
        },

        getCountdownQuiz(timer) {
            this.countdownQuiz = "00:00";
            this.quizInterval = 0;
            var countDownDate = moment().add(timer, "seconds");
            clearInterval(this.quizInterval);

            this.quizInterval = setInterval(() => {
                const diff = countDownDate.diff(this.$moment());
                if (diff <= 0) {
                    clearInterval(this.quizInterval);
                } else {
                    this.countdownQuiz = moment.utc(diff).format("mm:ss");
                }

                console.log(this.countdownQuiz);

                if (this.countdownQuiz === "00:00") {
                    firebase
                        .firestore()
                        .collection("live_class_room")
                        .doc(this.lcrId)
                        .update({
                            show_quiz: "",
                            end_time_quiz: 0,
                        });
                }
            }, 1000);
        },

        getCountdownResult() {
            this.countdownResult = "00:00";
            // this.countdownQuiz = "00:00";
            this.resultInterval = 0;
            clearInterval(this.resultInterval);
            // var countDownDate = moment().add(10, "seconds");

            // this.resultInterval = setInterval(() => {
            //   const diff = countDownDate.diff(this.$moment());
            //   if (diff <= 0) {
            //     clearInterval(this.resultInterval);
            //     firebase
            //       .firestore()
            //       .collection("live_class_room")
            //       .doc(this.lcrId)
            //       .update({
            //         show_result: "",
            //         end_time_result: 0,
            //       });
            //   } else {
            //     this.countdownResult = moment.utc(diff).format("mm:ss");
            //   }

            //   console.log(this.countdownResult);
            // }, 1000);

            var second = 10;
            this.resultInterval = setInterval(() => {
                second--;
                if (second <= 0) {
                    clearInterval(this.resultInterval);
                    firebase
                        .firestore()
                        .collection("live_class_room")
                        .doc(this.lcrId)
                        .update({
                            show_result: "",
                            end_time_result: 0,
                        });
                } else {
                    this.countdownResult = moment.utc(diff).format("mm:ss");
                }

                console.log(this.countdownResult);
            }, 1000);
        },

        getDetailQuiz(id) {
            var context = this;
            this.showQuiz = true;

            if (id) {
                var docRef = firebase
                    .firestore()
                    .collection("live_class_room")
                    .doc(this.lcrId)
                    .collection("quiz")
                    .doc("quiz_" + id);
                docRef.onSnapshot((doc) => {
                    var data = doc.data();
                    this.timer = data.timer;
                    this.dataQuiz = {
                        id: id,
                        total: data.total_choice,
                        answer: data.quiz_answer,
                    };
                });
            } else {
                context.$store.commit("showAlert", {
                    message: `Gagal menampilkan detail kuis!`,
                    type: "error",
                });
            }
        },

        onShowQuiz(id) {
            var context = this;
            this.countdownQuiz = "00:00";
            this.showResultDialog = false;

            var quiz_end_timer = moment(
                moment().add(context.timer, "seconds")
            ).valueOf();

            firebase
                .firestore()
                .collection("live_class_room")
                .doc(context.lcrId)
                .update({
                    show_quiz: "quiz_" + id,
                    end_time_quiz: quiz_end_timer,
                    show_result: "",
                    end_time_result: 0,
                });

            context.$store.commit("showAlert", {
                message: `Berhasil publish Quiz ` + id,
                type: "success",
            });

            // this.getCountdownQuiz(context.timer);
            this.quiz_active = id;
            this.showQuiz = false;
        },

        getResult(id) {
            var params = {
                live_class_room_id: this.lcrId,
                quiz_id: "quiz_" + id,
            };
            const context = this;
            context.result = [];

            if (id) {
                LiveClassTeacherService.getResult(params, function (response) {
                    if (response.success) {
                        if (response.data.A === undefined) {
                            var sumResultA = 0;
                        } else {
                            var sumResultA = Math.round(
                                (response.data.A / 100) * response.data.total
                            );
                        }

                        if (response.data.B === undefined) {
                            var sumResultB = 0;
                        } else {
                            var sumResultB = Math.round(
                                (response.data.B / 100) * response.data.total
                            );
                        }

                        if (response.data.C === undefined) {
                            var sumResultC = 0;
                        } else {
                            var sumResultC = Math.round(
                                (response.data.C / 100) * response.data.total
                            );
                        }

                        if (response.data.D === undefined) {
                            var sumResultD = 0;
                        } else {
                            var sumResultD = Math.round(
                                (response.data.D / 100) * response.data.total
                            );
                        }

                        if (response.data.E === undefined) {
                            var sumResultE = 0;
                        } else {
                            var sumResultE = Math.round(
                                (response.data.E / 100) * response.data.total
                            );
                        }

                        context.result = {
                            id: id,
                            total: response.data.total,
                            a: response.data.A,
                            b: response.data.B,
                            c: response.data.C,
                            d: response.data.D,
                            e: response.data.E,
                            sumA: sumResultA,
                            sumB: sumResultB,
                            sumC: sumResultC,
                            sumD: sumResultD,
                            sumE: sumResultE,
                            answer: response.data.quiz_answer,
                        };
                    }
                });
                this.showResult = true;
                this.isResult = true;
            } else {
                context.$store.commit("showAlert", {
                    message: `Gagal menampilkan detail hasil kuis!`,
                    type: "error",
                });
            }
        },

        publishResult(id) {
            var context = this;

            var result_end_timer = moment(
                moment().add(context.timer, "seconds")
            ).valueOf();

            firebase
                .firestore()
                .collection("live_class_room")
                .doc(context.lcrId)
                .update({
                    show_result: "quiz_" + id,
                    end_time_result: result_end_timer,
                    show_quiz: "",
                    end_time_quiz: 0,
                });

            context.$store.commit("showAlert", {
                message: `Berhasil publish Hasil Quiz ` + id,
                type: "success",
            });

            // this.getCountdownResult();

            context.showResult = false;
        },

        endPublishResult(id) {
            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .update({
                    show_result: "",
                    end_time_result: 0,
                    show_quiz: "",
                    end_time_quiz: 0,
                });

            this.isResult = false;
        },

        getStatusLive() {
            var docRef = firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId);
            docRef.onSnapshot((doc) => {
                this.statusLive = doc.data().status;
            });
        },

        getListStudent() {
            console.log(this.lcrId);
            try {
                var docRef = firebase
                    .firestore()
                    .collection("live_class_room")
                    .doc(this.lcrId)
                    .collection("attendance");
                docRef.onSnapshot((doc) => {
                    var student = [];
                    this.studentList = [];
                    doc.forEach((doc) => {
                        student = {
                            id: doc.id,
                            name: doc.data().student_name,
                            suspend: doc.data().suspend,
                            disable_chat: doc.data().disable_chat,
                        };
                        this.studentList.push(student);
                    });

                    this.studentCount = this.studentList.length;
                });
            } catch (error) {
                console.log("Get Data Attendance Error");
            }
        },

        onSuspendStudent(id) {
            this.isSuspend = true;

            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .collection("attendance")
                .doc(id)
                .update({
                    suspend: true,
                });
        },

        onUnsupendStudent(id) {
            this.isSuspend = false;

            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .collection("attendance")
                .doc(id)
                .update({
                    suspend: false,
                });
        },

        onDisabledStudent(id) {
            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .collection("attendance")
                .doc(id)
                .update({
                    disable_chat: true,
                });
        },

        onEnabledStudent(id) {
            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .collection("attendance")
                .doc(id)
                .update({
                    disable_chat: false,
                });
        },

        startLiveClass() {
            const context = this;

            if (context.differenceMin >= 0 && context.differenceMin > -16) {
                firebase
                    .firestore()
                    .collection("live_class_room")
                    .doc(this.lcrId)
                    .update({
                        status: "STARTED",
                    });
            } else {
                context.$store.commit("showAlert", {
                    message: `Belum waktunya mulai live class!`,
                    type: "error",
                });
            }
        },

        endLiveClass() {
            var now = new Date();

            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .update({
                    status: "FINISHED",
                    end_time: now,
                });
            this.isEndLive = false;
        },

        onDivertClass() {
            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .update({
                    status: "DIVERTED",
                });

            this.onDivert = false;
        },

        onWaitingClass() {
            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .update({
                    status: "WAITING",
                });

            this.onDivert = false;
        },

        disabledChat() {
            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .update({
                    status: "DISABLED_CHAT",
                });

            this.isDisabled = true;
        },

        enabledChat() {
            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .update({
                    status: "STARTED",
                });

            this.isDisabled = false;
        },

        scrollToBottom() {
            setTimeout(() => {
                const container = this.$el.querySelector("#scroll-target");
                if (container) container.scrollTop = container.scrollHeight;
            }, 200);
        },

        async fetchMessages() {
            try {
                var docRef = firebase
                    .firestore()
                    .collection("live_class_room")
                    .doc(this.lcrId)
                    .collection("message")
                    .orderBy("created_at");
                docRef.onSnapshot((doc) => {
                    var allMessages = [];
                    doc.forEach((doc) => {
                        allMessages.push(doc.data());
                        this.scrollToBottom();
                    });
                    this.messages = allMessages;
                });
            } catch (error) {
                console.log("Fetch Messages Error :", error);
            }
        },

        saveMessage() {
            this.chatLoading = true;
            var teacher_id = this.$ls.get("profiles").id;
            var teacher_first_name = this.$ls.get("profiles").firstName;
            var teacher_picture = this.$ls.get("profiles").picture;

            firebase
                .firestore()
                .collection("live_class_room")
                .doc(this.lcrId)
                .collection("message")
                .doc(`MSG_8989_${new Date()}`)
                .set({
                    url_img: teacher_picture,
                    message: this.message ? this.message : this.url_img,
                    type: 1,
                    user_id: teacher_id,
                    user_name: teacher_first_name,
                    created_at: this.$moment().valueOf(),
                })
                .then(() => {
                    this.url_img = "";
                    this.type = 1;
                    if (!this.fileProgress) this.fileName = "";
                    this.size = null;
                    this.chatLoading = false;
                    this.message = null;
                })
                .catch((err) => {
                    console.log("Save Message Error : ", err);
                });
        },
        async getResultQuiz(id) {
            this.showResultDialog = true;
            var params = {
                live_class_room_id: this.lcrId,
                quiz_id: "quiz_" + id,
            };

            try {
                await LiveClassTeacherService.getResult(params);

                var docRef = await firebase
                    .firestore()
                    .collection("live_class_room")
                    .doc(this.lcrId)
                    .collection("quiz_summary")
                    .doc("quiz_" + id);
                docRef.onSnapshot((doc) => {
                    this.result_quiz_data = doc.data();

                    this.fetchLiveQuiz(id);
                    this.getCountAnswer(id);
                });
            } catch (error) {
                console.log("Get Live Quiz Error : ", error.message);
            }
        },
        async fetchLiveQuiz(id) {
            try {
                firebase
                    .firestore()
                    .collection("live_class_room")
                    .doc(this.lcrId)
                    .collection("quiz")
                    .doc("quiz_" + id)
                    .get()
                    .then((doc) => {
                        const data_quiz = doc.data();

                        this.data_chart = {
                            ...this.result_quiz_data,
                            ...data_quiz,
                        };

                        this.setQuizTimer();
                    });
            } catch (error) {
                console.log("Get Live Quiz Error : ", error.message);
            }
        },
        async getCountAnswer(id) {
            this.loading_answer = true;
            try {
                var docRef = firebase
                    .firestore()
                    .collection("live_class_room")
                    .doc(this.lcrId)
                    .collection("answer")
                    .doc("quiz_" + id)
                    .collection("student");
                docRef.onSnapshot((querySnapshot) => {
                    var total_answer = 0;
                    querySnapshot.forEach(() => {
                        total_answer++;
                    });
                    this.answer_count = total_answer;
                    this.quiz_percentation = Math.ceil(
                        (total_answer / this.studentCount) * 100
                    );
                    this.loading_answer = false;
                });
            } catch (error) {
                console.log("Get Attendance Error : ", error);
            }
        },
        setQuizTimer() {
            clearInterval(this.quizInterval2);
            const end_timer = this.$moment(this.data_class.end_time_quiz);

            this.quizInterval2 = setInterval(() => {
                const diff = end_timer.diff(this.$moment());
                if (diff <= 0) {
                    clearInterval(this.quizInterval2);
                } else {
                    this.countdown_quiz = this.$moment
                        .utc(diff)
                        .format("mm:ss");
                }
            }, 1000);
        },
    },
};
</script>

<style>
.select_key {
    height: 50px;
}
</style>



// WEBPACK FOOTER //
// LiveClassTeacherDetail.vue?ca1b41d0